import React from "react"

import { RoomActionsOverlayView } from "./RoomActionsOverlayView"
import { useRoomActionsOverlayViewModel } from "./hooks/useRoomActionsOverlayViewModel"

export interface RoomActionsOverlayPayload {
  projectID: string
  roomID: string
}

interface RoomActionsOverlayProps {
  payload: RoomActionsOverlayPayload
}

export const RoomActionsOverlay = React.memo(
  ({ payload }: RoomActionsOverlayProps) => (
    <RoomActionsOverlayView {...useRoomActionsOverlayViewModel(payload)} />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    ROOM_ACTIONS_OVERLAY: RoomActionsOverlayPayload
  }
}
